import { EventWithType } from './base.presenter';
import { StatefulPresenter, StatefulState, StatefulStateType } from './stateful.presenter';

export abstract class FetchPresenter<
  ViewState extends StatefulState<any, any> = StatefulState<any, any>,
  ViewEvent extends EventWithType = EventWithType,
  SideEffect = {},
> extends StatefulPresenter<ViewState, ViewEvent, SideEffect> {
  /**
   * Default state
   */
  protected defaultState: StatefulStateType = 'Loading';

  /**
   * {@inheritDoc}
   */
  protected defaultViewState(): ViewState {
    return {
      type: this.defaultState,
      data: undefined,
      error: undefined,
    } as ViewState;
  }

  /**
   * Check if presenter has data regardless of the state
   */
  public get hasData(): boolean {
    return !!this.viewState.data;
  }

  /**
   * Check if data is empty
   * This property should be called after checking if data is loaded
   */
  public get isEmpty(): boolean {
    return this.isLoaded && (!this.viewState.data || this.viewState.data.length === 0);
  }
}
